import React, {Component} from "react";
import {SortableTableHeader} from "../../components/table/sortable-table-header";

export default class ContractTradesStratsTableHeader extends Component {

  static Layout = [
    { column: "tradingStrategyTypeName", name: "Type"},
    { column: "periodFromDescription", width: 2, name: "Period From" },
    { column: "periodToDescription", width: 2, name: "Period To" },
    { column: "virtualCapEffectiveFromDate", name: "Effective From Date" },
    { column: "virtualCapInitialCost", name: "Initial" }
  ];

  render() {
    return (
        <SortableTableHeader column={this.props.column} direction={this.props.direction} onChangeSort={this.props.onChangeSort} headings={ContractTradesStratsTableHeader.Layout}/>
    )
  }
}